
import { useMutation, useQuery } from "react-query";
import { endConversations, showConversations } from "../../MyApi/conversations";
import NavTabsBar from "../../Components/UI/navtabsbar";
import { useEffect, useRef, useState } from "react";
import ChatBubble from "./chatBubble";
import ChatActions from "./chatactions";
import Button from "../../Components/UI/buttonGlobal";
import StatusBadge from "./statusBadge";
import usePusher from "../../utils/usepusher";
import { toast } from "react-toastify";
 
const ChatTab = ({ticketId, onShowOrderDetails  ,refetch:refetchChat ,setUserId}) => {
  const { data, isLoading, refetch } = useQuery(
    ["showConversations", ticketId],
    () => showConversations(ticketId),{
      enabled: !!ticketId,
    }
  );
  const user = JSON.parse(localStorage.getItem("user")) 
  const adminId =user.id ;
  const [messagesArr, setMessagesArr] = useState([]);
    const messagesEndRef = useRef(null);
   const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };
 usePusher({ channelName:`private-conversation.${ticketId}`, eventName: "message.sent" ,onEvent:(event)=>{
   if(!event.id) return ;
   setMessagesArr((prev)=>[...prev ,event])
   scrollToBottom()
 }})
  const conversation = data?.data?.conversation || {};
  const conversationStatus = conversation?.status;
  const messages = data?.data?.messages || {};


  const { couier, start_time ,vendor ,user :userApi ,admin_id:adminIdConversation ,order_id ,user_id} = conversation;

  const [activeTab, setActiveTab] = useState("chats");

  useEffect(() => {
    onShowOrderDetails(order_id || null);

  },[order_id ,conversation ,ticketId]);
console.log('order_id', order_id)
 useEffect(() => { 
  setUserId(user_id)
  }, [conversation ,ticketId])

  const endMutation = useMutation({
    mutationKey: ["endConversations"],
    mutationFn: (posData) => endConversations(posData, ticketId  ),
    onSuccess: (data) => {
      refetch();
      refetchChat();
      toast.success(`${data.message}`); 
    },
    onError: (error) => {
    toast.error(`${error.response.data.message}`);
    }
  });
  useEffect(() => {
    if (messages && data) setMessagesArr(messages?.data);
  }, [data]);
  const tabs = [
    // { id: 1, key: "notes", label: "ملاحظات علي المحادثة" },
    { id: 2, key: "chats", label: "المحادثات"  ,permission:"handle_customer_service"},
  ];
  const onTabChange = (tab) => {
    setActiveTab(tab);
  };
  const now = new Date();

  const formatted = now.toLocaleString(undefined, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  const formattedDate =
    now.getFullYear() +
    "-" +
    String(now.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(now.getDate()).padStart(2, "0");
  console.log("formattedDate", formattedDate);
  // الوقت فقط
  const formattedTime =
    String(now.getHours()).padStart(2, "0") +
    ":" +
    String(now.getMinutes()).padStart(2, "0") +
    ":" +
    String(now.getSeconds()).padStart(2, "0");
  const handleEndConversation = () => {
    endMutation.mutate({
      end_time: `${formattedDate} ${formattedTime}`,
      _method: "PUT",
    });
  };


    if (!ticketId) {
    return <div className="text-center text-muted py-5">اختر تذكرة لعرض المحادثة</div>;
  }
  return (
    <div  className="chat-modal">
      <header className="border-0 justify-content-between d-flex p-3">
        <h5> محادثة العميل </h5>
   
      </header>

        <div className="user-info-card mb-3">
          <div>
            <h6 className="mb-3">{couier?.name ||vendor?.full_name}</h6>
            <div>{couier?.phone ||vendor?.phone ||userApi?.phone}</div>
          </div>
          <div>
            <h6 className="mb-3 start-time">{start_time}</h6>
            <div className="text-green">
              #{couier?.id ||vendor?.id}{" "}
              <span>
                <StatusBadge
                  status={
                    conversationStatus === "ENDED"
                      ? "محادثة منتهية"
                      : conversationStatus === "PENDING"
                      ? "pending"
                      : conversationStatus ==="ACTIVE" ?"active":""
                  }
                  statusLabel={
                    conversationStatus === "ENDED"
                      ? "محادثة منتهية"
                      : conversationStatus === "PENDING"
                      ? "pending"
                      :  conversationStatus ==="ACTIVE" ?"active":conversationStatus ==="inActive" ?"inActive":""
                  }
                />
              </span>
            </div>
          </div>
        </div>
   
        <NavTabsBar
          activeTab={activeTab}
          tabs={tabs}
          onTabChange={onTabChange} 
        />
        <ChatBubble
        scrollToBottom={scrollToBottom}
          messages={messagesArr}
          couier={couier}
          vendor={vendor}
          user={userApi}
          isLoading={isLoading}
          messagesEndRef={messagesEndRef}
          
        />
        {conversationStatus === "ENDED" || (conversationStatus ==="ACTIVE" && adminId !==adminIdConversation ) ? null :(
          <ChatActions modalId={ticketId} setMessagesArr={setMessagesArr} refetch={refetch} refetchChat={refetchChat} scrollToBottom={scrollToBottom}  />
        )}
   
      <div className="border-0 d-flex justify-content-start ">
        {conversationStatus === "ENDED"|| (conversationStatus ==="ACTIVE" && adminId !==adminIdConversation ) ? null : (
          <Button
            className="w-auto btn-sm btn-danger rounded-3 mt-3"
            onClick={handleEndConversation}
            label={"إغلاق المحادثة"}
            isLoading={endMutation.isLoading}
            disabled={endMutation.isLoading}
          ></Button>
        )}
 
      </div>
    </div>
  );
};

export default ChatTab;
